import { DefaultCachePolicy } from '@warp-drive/core/store';
import type { Store } from '@warp-drive/core';
import type { RequestKey } from '@warp-drive/core/types/identifier';

/** Retains native successful-response expiry without reusing cached failures on a later read. */
export default class TioCachePolicy extends DefaultCachePolicy {
  /**
   * Failed documents expire on the next caller request; this does not schedule a retry.
   * @param key Identity of the request document being considered for reuse.
   * @param store Store whose cache owns that document.
   * @returns Whether to fetch instead of reusing the document, delegating success expiry unchanged.
   */
  override isHardExpired(key: RequestKey, store: Store): boolean {
    const document = store.cache.peekRequest(key);
    return Boolean(document && 'error' in document) || super.isHardExpired(key, store);
  }
}
